var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 32C25.0604 32 32 25.0604 32 16.5C32 7.93959 25.0604 1 16.5 1C7.93959 1 1 7.93959 1 16.5C1 25.0604 7.93959 32 16.5 32Z",
    fill: "#E5FCF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9385 25.7374C27.4929 23.802 25.6158 22.2305 23.4564 21.1477C21.297 20.0649 18.9149 19.5008 16.4992 19.5C14.0835 19.4992 11.701 20.0619 9.54092 21.1434C7.38084 22.2248 5.50277 23.7951 4.05597 25.7296C5.49542 27.6739 7.37042 29.2538 9.53063 30.3427C11.6908 31.4317 14.0761 31.9993 16.4953 32C18.9144 32.0008 21.3001 31.4347 23.461 30.3471C25.6219 29.2596 27.4979 27.6808 28.9385 25.7374Z",
    fill: "#00EFC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.5C19.8137 17.5 22.5 14.8137 22.5 11.5C22.5 8.18629 19.8137 5.5 16.5 5.5C13.1863 5.5 10.5 8.18629 10.5 11.5C10.5 14.8137 13.1863 17.5 16.5 17.5Z",
    fill: "#00EFC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.41f59f25174054bb043bc7c566ffbbaa.svg";
export { ForwardRef as ReactComponent };